import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './index.scss';

const AlertCard = props => {
  const {
    showResponse,
    title,
    descriptionHat,
    goToPath,
    data,
    createdCallback,
    buttonText,
    goToPath2,
    buttonText2
  } = props;

  return (
    <div data-testid="alert-card" className={`AlertCard card ${showResponse ? '' : 'hide'}`}>
      <div className="content">
        <span className="title">{title}</span>
        <p className="description-hat">{descriptionHat}</p>
      </div>
      <div
        className={`card-action right-align ${goToPath2 ? 'double' : ''}`}
        onClick={createdCallback}
        role="button"
      >
        <Link
          to={{
            pathname: goToPath,
            state: data,
            params: { showResponse }
          }}
          className="link"
        >
          {buttonText}
        </Link>
      </div>
      <div
        className={`card-action right-align ${goToPath2 ? 'double' : 'hide'}`}
        onClick={createdCallback}
        role="button"
      >
        <Link
          to={{
            pathname: goToPath2,
            state: data,
            params: { showResponse }
          }}
          className="link"
        >
          {buttonText2}
        </Link>
      </div>
    </div>
  );
};

AlertCard.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionHat: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};

export default AlertCard;
